import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__/index.ts';
import { meQuery } from '@/routes/_app/loader.ts';

const CreateStripeSellerAccount = gql(`
  mutation CreateStripeSellerAccount {
    createStripeSellerAccount {
      __typename
      ...StripeSellerProfileFragment
    }
  }
`);

export const useCreateStripeSellerAccount = () => {
  const toast = useToast();

  const [createStripeSellerAccountMutation, result] = useMutation(
    CreateStripeSellerAccount,
    {
      onError() {
        toast.error({
          title: 'Failed to create a Stripe seller account',
          subTitle: 'Please try again',
        });
      },
      update(cache, { data }) {
        if (data?.createStripeSellerAccount) {
          const existingMeData = cache.readQuery({
            query: meQuery,
          });

          if (existingMeData?.me) {
            cache.writeQuery({
              query: meQuery,
              data: {
                me: {
                  ...existingMeData.me,
                  protectedFields: {
                    ...existingMeData.me.protectedFields!,
                    stripeExpressSellerAccount: data.createStripeSellerAccount,
                  },
                },
              },
            });
          }
        }
      },
    },
  );

  return [createStripeSellerAccountMutation, result] as const;
};
